/* KPI Events */
export const AD_DISPLAYED = 'AD_DISPLAYED';
export const PAGE_HIDE = 'PAGE_HIDE';
export const VISIBILITY_CHANGE_HIDDEN = 'VISIBILITY_CHANGE_HIDDEN';

/* Error Events */
export const RENDERING_ERROR = 'RENDERING_ERROR';

/* Error Types */
export const UNLOAD_ERROR = 'UNLOAD_ERROR';
export const UNLOAD_FRAME_ERROR = 'UNLOAD_FRAME_ERROR';

export type SUPPLY_MONITORING_EVENT_TYPE =
  | typeof AD_DISPLAYED
  | typeof RENDERING_ERROR
  | typeof PAGE_HIDE
  | typeof VISIBILITY_CHANGE_HIDDEN;

type SUPPLY_MONITORING_EVENT_ERROR_TYPE =
  | typeof UNLOAD_ERROR
  | typeof UNLOAD_FRAME_ERROR;

interface SupplyMonitoringEventErrorFields {
  error_type?: SUPPLY_MONITORING_EVENT_ERROR_TYPE;
  error_content?: string;
}

interface AdditionalSupplyMonitoringEventFields {
  details?: string;
}

export type OptionalSupplyMonitoringEventFields =
  | SupplyMonitoringEventErrorFields
  | AdditionalSupplyMonitoringEventFields;
